var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-fade-transition',[(_vm.loader)?_c('div',{staticClass:"loaderArea"},[_c('div',{staticClass:"backLoader"}),_c('div',{staticClass:"loaderSpinner mt-8"},[_c('lottie-animation',{ref:"anim",attrs:{"animationData":require('../../assets/animation/loader.json'),"loop":true,"autoPlay":true}})],1)]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }